import IconPDF from './pdf.svg';
import IconXLS from './xls.svg';
import IconDOC from './doc.svg';
import IconPNG from './png.svg';

const EXTENSION_MAP: Record<string, string> = {
  pdf: IconPDF,
  doc: IconDOC,
  docx: IconDOC,
  xls: IconXLS,
  xlsx: IconXLS,
  csv: IconXLS,
  png: IconPNG,
  jpg: IconPNG,
  jpeg: IconPNG,
  webp: IconPNG,
  svg: IconPNG,
};

export function getFileIcon(filename: string): string {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  return EXTENSION_MAP[ext] ?? '';
}
